import GS from '../../grafsync/grafsync';

// Allow a user to open a link in a new browser tab
function getNewTabLink(link) {
    const tabLink = "?graphologi-target=" + GS.getActiveSubscriptionBucket() + "&subscription=" + GS.getActiveSubscription() + "#";
    const withTabLink1 = link.substring(link, link.indexOf("#"));
    const withTabLink2 = link.substring(link.indexOf("#") + 1);
    const fullTabLink = withTabLink1 + tabLink + withTabLink2;
    window.open(window.location.origin + "/gs" + fullTabLink);
}

function sortLabels(labels) {
    return labels.sort(function (a, b) {
        let orderA = a.literalForm && Object.keys(a.literalForm) && Object.keys(a.literalForm).length > 0 ?
            a.literalForm[Object.keys(a.literalForm)[0]].toLowerCase()
            :
            "";
        let orderB = b.literalForm && Object.keys(b.literalForm) && Object.keys(b.literalForm).length > 0 ?
            b.literalForm[Object.keys(b.literalForm)[0]].toLowerCase()
            :
            "";
        if (orderA < orderB) return -1;
        if (orderA > orderB) return 1;
        return 0;
    });
}

function getPairwiseValues(data) {
    const { prefLabel, altLabel } = data;
    let existingValues = {};
    const altLangs = altLabel && altLabel !== undefined ? Object.keys(altLabel) : [];
    const prefLangs = prefLabel && prefLabel !== undefined ? Object.keys(prefLabel) : [];
    const uniqueLangKeys = new Set([...altLangs, ...prefLangs]);
    uniqueLangKeys.forEach(lang => {
        const altValues = altLabel && altLabel[lang] ? altLabel[lang] : [];
        const prefValues = prefLabel && prefLabel[lang] ? prefLabel[lang] : [];
        const altValueList = Array.isArray(altValues) ? altValues : [altValues];
        const prefValueList = Array.isArray(prefValues) ? prefValues : [prefValues];
        const uniqueValues = [...altValueList, ...prefValueList];
        existingValues[lang] = uniqueValues;
    });
    return existingValues;
}

export {
    sortLabels,
    getNewTabLink,
    getPairwiseValues
};